import * as CookieConsent from 'vanilla-cookieconsent'

export function initCookieConsent() {
  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {},
    },
    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We use cookies',
            description:
              'We use cookies to ensure you get the best experience on our site and to analyze how it is used.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject non-essential',
            showPreferencesBtn: 'Manage preferences',
          },
          preferencesModal: {
            title: 'Cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject non-essential',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close',
            sections: [
              {
                title: 'Strictly necessary cookies',
                description:
                  'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                linkedCategory: 'necessary',
              },
              // {
              //   title: 'Analytics cookies',
              //   description:
              //     'These cookies help us understand how visitors interact with the website.',
              //   linkedCategory: 'analytics',
              // },
            ],
          },
        },
      },
    },
    onFirstConsent: ({cookie}) => {
      window.location.reload()
    },
  })
}
